import {
  ProgramVerification,
  SectionVerificationResult,
} from '@trp/community/program-verification/interfaces';
import { ProgramOrSectionType } from '@trp/community/interfaces';
import { VERIFICATION_EXPIRY_DAYS } from './verification-expiry';

export function getSectionVerificationStatus(
  section: ProgramOrSectionType,
  verifications: Pick<ProgramVerification, 'property' | 'createdAt' | 'programOrSectionType'>[]
): SectionVerificationResult {
  const sectionVerifications = verifications.filter(
    (v) => v.programOrSectionType === section
  );

  if (sectionVerifications.length === 0) {
    return { status: 'not-yet-verified', timestamp: null };
  }

  const mostRecentTimestamp = sectionVerifications.reduce((latest, v) =>
    v.createdAt > latest.createdAt ? v : latest
  ).createdAt;

  const hasExpired = sectionVerifications.some((v) => {
    const ageInMs = Date.now() - new Date(v.createdAt).getTime();
    const ageInDays = ageInMs / (1000 * 60 * 60 * 24);
    return ageInDays >= VERIFICATION_EXPIRY_DAYS;
  });

  if (hasExpired) {
    return { status: 'verification-expired', timestamp: mostRecentTimestamp };
  }

  return { status: 'verified', timestamp: mostRecentTimestamp };
}
